import { Box } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { map } from 'lodash'
import { useRequestsStore } from '../../../../store/storeRequests'
import { theme } from '../../../../theme'
import Citation from './Citation'

const Citations = () => {
    const { messageCitations } = useRequestsStore((state) => state)
    const items = map(messageCitations, (citation, index) => (
        <Box
            sx={{
                padding: '8px 0',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                '& + &': {
                    borderTop: '1px solid #F4F4F6',
                },
            }}>
            <Citation key={citation.link} citation={citation} index={index} />
        </Box>
    ))

    return (
        <Grid
            id="request_citations"
            sx={{
                display: 'flex',
                padding: '16px 8px',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'column',
                gap: '4px',
                height: 'calc(100dvh - 195px)',
                overflow: 'auto',
                [theme.breakpoints.down('sm')]: {
                    width: `100%`,
                    height: 'calc(100dvh - 152px)',
                },
            }}>
            {items}
        </Grid>
    )
}

export default Citations
